var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#1f2923",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40002 7.99999C3.40002 10.5405 5.45951 12.6 8.00002 12.6C10.5405 12.6 12.6 10.5405 12.6 7.99999C12.6 5.45948 10.5405 3.39999 8.00002 3.39999C5.45951 3.39999 3.40002 5.45948 3.40002 7.99999ZM2.40002 7.99999C2.40002 11.0928 4.90723 13.6 8.00002 13.6C11.0928 13.6 13.6 11.0928 13.6 7.99999C13.6 4.9072 11.0928 2.39999 8.00002 2.39999C4.90723 2.39999 2.40002 4.9072 2.40002 7.99999ZM8.40002 5.59999C8.40002 5.82091 8.22094 5.99999 8.00002 5.99999C7.77911 5.99999 7.60002 5.82091 7.60002 5.59999C7.60002 5.37908 7.77911 5.19999 8.00002 5.19999C8.22094 5.19999 8.40002 5.37908 8.40002 5.59999ZM8.00002 7.19999C7.77911 7.19999 7.60002 7.37908 7.60002 7.59999V10.8C7.60002 11.0209 7.77911 11.2 8.00002 11.2C8.22094 11.2 8.40002 11.0209 8.40002 10.8V7.59999C8.40002 7.37908 8.22094 7.19999 8.00002 7.19999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLine);
export default __webpack_public_path__ + "static/media/info-line.5e9776ee325531965f74b852388b11a2.svg";
export { ForwardRef as ReactComponent };